// extracted by mini-css-extract-plugin
export default {"MultiSelectItem":"nX0rG_bOvlBUhikVcpqD","text":"jOfACou8KN3Eem2RU_1b"};